import { render, staticRenderFns } from "./Billingpage.vue?vue&type=template&id=0225cdac&"
import script from "./Billingpage.vue?vue&type=script&lang=js&"
export * from "./Billingpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports